import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  ApiProduct,
  ApiProductsService,
} from 'src/app/services/api-products.service';
import {
  ApiSubscription,
  ApiSubscriptionsService,
} from 'src/app/services/api-subscriptions.service';
import { Tenant } from 'src/app/services/tenants.service';

@Component({
  selector: 'app-add-api-subscription',
  templateUrl: './add-api-subscription.component.html',
  styleUrl: './add-api-subscription.component.scss',
})
export class AddApiSubscriptionComponent {
  @Input() tenant?: Tenant;

  @Output() apiSubscriptionAdded = new EventEmitter<ApiSubscription>();

  apiProducts?: ApiProduct[];
  loadingApiProducts = false;
  errorFetchingApiProducts = '';

  startDate: string = new Date().toISOString().slice(0, 10);
  selectedApiProduct?: ApiProduct;

  addingSubscription = false;
  errorAddingSubscription = '';

  constructor(
    private apiProductsService: ApiProductsService,
    private apiSubscriptionsService: ApiSubscriptionsService
  ) {}

  ngOnInit(): void {
    this.getAllApiProducts();
  }

  clearSelectedValues() {
    this.selectedApiProduct = undefined;
  }

  getAllApiProducts() {
    this.loadingApiProducts = true;
    this.apiProductsService.getAllApiProducts().subscribe({
      next: (apiProducts) => {
        this.loadingApiProducts = false;
        this.apiProducts = apiProducts;
      },
      error: (err) => {
        this.loadingApiProducts = false;
        this.errorFetchingApiProducts = err;
      },
    });
  }

  addSubscription() {
    if (!this.tenant) {
      this.errorAddingSubscription = 'Tenant is required';
      console.error(new Error('Tenant is required'));
      return;
    }

    if (!this.selectedApiProduct) {
      this.errorAddingSubscription = 'API product is required';
      console.error(new Error('API product is required'));
      return;
    }

    if (!this.startDate) {
      this.errorAddingSubscription = 'Start date is required';
      console.error(new Error('Start date is required'));
      return;
    }

    this.addingSubscription = true;
    this.apiSubscriptionsService
      .createApiSubscription({
        tenant_id: this.tenant!.id,
        api_product_id: this.selectedApiProduct!.id,
        start_date: new Date(this.startDate),
        active: true,
      })
      .subscribe({
        next: (res) => {
          this.addingSubscription = false;
          this.apiSubscriptionAdded.emit(res);
        },
        error: (err) => {
          this.addingSubscription = false;
          this.errorAddingSubscription = err;
        },
      });
  }
}
